





































import SharedReportNavElement from './SharedReportNavElement.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

enum SectionType {
  Intro = 'intro',
  Section = 'section',
  Orphans = 'orphans',
  Question = 'question',
  Prototypes = 'prototypes',
  Summary = 'summary',
  TempPlaceholder = 'tempPlaceholder'
}

interface NavElement {
  displayOrder: number,
  scrollPosition: number,
  type: SectionType,
  page: any
}

interface NavElSection {
  displayOrder: number,
  type: SectionType,
  children: NavElement[]
}

@Component({
  components: {
    SharedReportNavElement
  }
})
export default class SharedReportNav extends Vue {
  @Prop() pages!: any
  @Prop() report!: any
  @Prop() activePage!: any
  @Prop() summary!: any
  @Prop() everything!: any
  @Prop() elementUnderDrag!: any
  @Prop() editable!: boolean

  underDrag:boolean = false;

  createTempSection (sectionCounter:number):NavElSection {
    return {
      displayOrder: sectionCounter,
      type: SectionType.TempPlaceholder,
      children: []
    }
  }

  firstPageOfSection (type: SectionType, page: NavElement, tempSection: NavElSection, sectionCounter: number):void {
    Object.assign(tempSection, {
      type,
      children: [page],
      displayOrder: sectionCounter
    })
    sectionCounter++
  }

  get navElementSections (): NavElSection[] {
    const filteredPages = this.pages.filter((page:any) => page.type !== 'prototypes' || this.prototypesCount > 0)
    const sectionedPages: NavElSection[] = []
    let sectionCounter = 0
    let tempSection = this.createTempSection(sectionCounter++)
    const pushTemp = ():void => {
      sectionedPages.push(tempSection)
      tempSection = this.createTempSection(sectionCounter++)
    }
    for (let i = 0; i < filteredPages.length; i++) {
      const page = filteredPages[i]
      // Display order should already be present. This is a failsafe to handle legacy reports.
      if (page.displayOrder === undefined) page.displayOrder = tempSection.children.length
      if (page.type === 'intro') {
        this.firstPageOfSection(SectionType.Intro, page, tempSection, sectionCounter++)
        pushTemp()
      } else if (page.type === 'section') {
        if (tempSection.children.length > 0) pushTemp()
        this.firstPageOfSection(SectionType.Section, page, tempSection, sectionCounter++)
      } else if (page.type === 'question') {
        if (tempSection.children.length === 0) this.firstPageOfSection(SectionType.Orphans, page, tempSection, sectionCounter++)
        else tempSection.children.push(page)
      } else if (page.type === 'prototypes') {
        // TODO: Figure out the best way to handle this.
      } else if (page.type === 'summary') {
        if (tempSection.children.length > 0) pushTemp()
        this.firstPageOfSection(SectionType.Summary, page, tempSection, sectionCounter++)
        pushTemp()
      }
    }
    if (tempSection.children.length > 0) pushTemp() // This should never happen. It's a failsafe.
    return sectionedPages
  }

  styleAndCacheDrag (event:any, page:any) {
    event.target.classList.add('under-drag')
    setTimeout(function () {
      event.target.classList.remove('under-drag')
    }, 1)
    const { displayOrder } = page
    const { parentIdx, idx } = page.page
    const dragData = JSON.stringify({
      parentIdx, idx, displayOrder
    })
    event.dataTransfer.setData('application/json', dragData)
    this.underDrag = true
  }

  get prototypesCount ():any {
    var allPrototypes = this.everything.$refs.prototypes.prototypes
    return Object.keys(allPrototypes).length
  }

  clickNav (item:any) {
    this.$emit('click', item)
  }

  updateDisplayOrder (event:any, page:any) {
    const dropTargetIsQuestion = event.target.classList.contains('nav-question')
    const drag = JSON.parse(event.dataTransfer.getData('application/json'))
    const drop = { parentIdx: page.page.parentIdx, displayOrder: page.displayOrder }
    if (dropTargetIsQuestion && drag.parentIdx === drop.parentIdx) {
      this.$emit('tests-reorder', { drag, drop })
    }
  }

  toggleDragOverStyling (event:any, methodName:string) {
    const targetIsNavQuestion = event.target.classList.contains('nav-question')
    if (this.underDrag && targetIsNavQuestion) {
      event.target.classList[methodName]('drag-hover')
    }
  }

  cleanupDrag () {
    document.querySelectorAll('.nav-question').forEach(
      questionEl => {
        questionEl.classList.remove('drag-hover')
      }
    )
    this.underDrag = false
  }
}
